<script>
export default {
  name: 'TouristPrivacyCard',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    goComplaintDetail (item) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${this.globalApp.getSystemInfo().host}team-supervision/supervision-app/#/cockpit_app/PrivateInfoDetail?data=${encodeURIComponent(JSON.stringify({id:item.id}))}`,
          isFullScreen: 1,
          setTitle: "敏感数据查看审批",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        })
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-action line line_bottom">
      <div class="card-action__name">待审批</div>
      <div class="card-action__btn" @click="goComplaintDetail(data)">
        立即处理
      </div>
    </div>
    <div class="card-title">敏感数据查看申请</div>
    <div class="list-item">
      <span class="list-item__name">申请部门：</span>
      <span class="list-item__cont">{{ data.orgName }}</span>
    </div>
    <div class="list-item">
      <span class="list-item__name">申请人姓名：</span>
      <span class="list-item__cont">{{ data.creatorName }}</span>
    </div>
    <div class="list-item">
      <span class="list-item__name">申请行程单号：</span>
      <span class="list-item__cont text-primary">{{ data.teamId }}</span>
    </div>
    <div class="list-item">
      <span class="list-item__name">申请时间：</span>
      <span class="list-item__cont">{{ data.createTime }}</span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.card {
  background: #fff;
  padding: 12px;
  font-size: 14px;
  margin-bottom: 12px;

  &-title {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
  }

  &-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-bottom: 12px;
    padding-bottom: 12px;

    &__name {
      font-size: 14px;
      font-weight: 600;
    }

    &__btn {
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      padding: 8px;
      background-color: #36b374;
      border-radius: 2px;
      margin-left: 8px;
    }
  }
}

.list-item {
  margin-bottom: 12px;
  color: #666;
  display: flex;

  &__name {
    width: 100px;
  }

  &__cont {
    flex: 1;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.text-primary {
  color: #36b374;
}</style>